var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C4.93209 22 0 17.0679 0 11C0 4.93209 4.93209 0 11 0C17.0679 0 22 4.93209 22 11C22 17.0679 17.0679 22 11 22ZM11 1.53488C5.7814 1.53488 1.53488 5.7814 1.53488 11C1.53488 16.2186 5.7814 20.4651 11 20.4651C16.2186 20.4651 20.4651 16.2186 20.4651 11C20.4651 5.7814 16.2186 1.53488 11 1.53488Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.8606C10.5805 15.8606 10.2326 15.5127 10.2326 15.0931V9.97685C10.2326 9.55732 10.5805 9.20941 11 9.20941C11.4196 9.20941 11.7675 9.55732 11.7675 9.97685V15.0931C11.7675 15.5127 11.4196 15.8606 11 15.8606Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 7.93013C10.8669 7.93013 10.7339 7.89943 10.6111 7.84827C10.4883 7.79711 10.3758 7.72548 10.2734 7.63338C10.1813 7.53106 10.1097 7.42873 10.0585 7.29571C10.0074 7.17292 9.97668 7.0399 9.97668 6.90687C9.97668 6.77385 10.0074 6.64083 10.0585 6.51804C10.1097 6.39524 10.1813 6.28269 10.2734 6.18036C10.3758 6.08827 10.4883 6.01664 10.6111 5.96548C10.8567 5.86315 11.1432 5.86315 11.3888 5.96548C11.5116 6.01664 11.6241 6.08827 11.7265 6.18036C11.8185 6.28269 11.8902 6.39524 11.9413 6.51804C11.9925 6.64083 12.0232 6.77385 12.0232 6.90687C12.0232 7.0399 11.9925 7.17292 11.9413 7.29571C11.8902 7.42873 11.8185 7.53106 11.7265 7.63338C11.6241 7.72548 11.5116 7.79711 11.3888 7.84827C11.266 7.89943 11.133 7.93013 10.9999 7.93013Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.0cc30b19fec66fc513f858dcbbbff753.svg";
export { ForwardRef as ReactComponent };